<ng-container *ngIf="isToolSubNav">
  <a
    class="button p-x-lg"
    routerLink="/catalogue/tools"
    [ngClass]="{
      'is-link':
        currentPath.substring(0, '/catalogue/tools'.length) ===
        '/catalogue/tools',
      'is-white':
        currentPath.substring(0, '/catalogue/tools'.length) !==
        '/catalogue/tools'
    }"
    >Show tools</a
  >
  <a
    class="button p-x-lg"
    routerLink="/catalogue/tool-use-cases"
    [ngClass]="{
      'is-white':
        currentPath.substring(0, '/catalogue/tool-use-cases'.length) !==
        '/catalogue/tool-use-cases',
      'is-link':
        currentPath.substring(0, '/catalogue/tool-use-cases'.length) ===
        '/catalogue/tool-use-cases'
    }"
    >Show use cases</a
  >
</ng-container>
<ng-container *ngIf="isMetricSubNav">
  <a
    class="button p-x-lg"
    routerLink="/catalogue/metrics"
    [ngClass]="{
      'is-white':
        currentPath.substring(0, '/catalogue/metrics'.length) !==
        '/catalogue/metrics',
      'is-link':
        currentPath.substring(0, '/catalogue/metrics'.length) ===
        '/catalogue/metrics'
    }"
    >Show metrics</a
  >
  <a
    class="button p-x-lg is-link"
    routerLink="/catalogue/metric-use-cases"
    [ngClass]="{
      'is-white':
        currentPath.substring(0, '/catalogue/metric-use-cases'.length) !==
        '/catalogue/metric-use-cases',
      'is-link':
        currentPath.substring(0, '/catalogue/metric-use-cases'.length) ===
        '/catalogue/metric-use-cases'
    }"
    >Show use cases</a
  >
</ng-container>
